module.exports = __webpack_public_path__ + "img/Architectures_C.7bf19c26.svg";